import React, { CSSProperties } from "react";
import { Seat } from "../../../models/Seat";
import { Exercise } from "../../../models/Exercise";
import LoadableComponent from "../../../../features/Loading/LoadableComponent";
import useCinemaHallDrawManager from "./hooks/useCinemaHallDrawManager";
import { useTranslation } from "react-i18next";

interface IProps {
  exercise: Exercise;
}

const CinemaHallDraw: React.FC<IProps> = ({ exercise }: IProps) => {
  const { loading, cinemaHall, handleSeat, seatStausClass } = useCinemaHallDrawManager(exercise);
  const { t } = useTranslation();
  const isScreen = (name: string) => name.toUpperCase() === "EKRAN";
  const style = (seat: Seat) => {
    if (isScreen(seat.name)) {
      return {
        left: `${seat.x}px`,
        top: `${seat.y}px`,
        width: `${seat.width}px`,
        height: "0px",
        borderTop: `${seat.height}px solid white`,
        borderLeft: `${seat.height + 20}px solid transparent`,
        borderRight: `${seat.height + 20}px solid transparent`,
      } as CSSProperties;
    } else {
      return {
        left: `${seat.x}px`,
        top: `${seat.y}px`,
        lineHeight: `${seat.height}px`,
        width: `${seat.width}px`,
        height: `${seat.height}px`,
      } as CSSProperties;
    }
  };

  return (
    <LoadableComponent loading={loading}>
      {cinemaHall === null || cinemaHall.rowZones.length === 0 ? (
        <h3>{t("brak_danych")}</h3>
      ) : (
        <React.Fragment>
          <div className={"cinema-hall-view"}>
            {cinemaHall.rowZones.map((rowZone, index) => (
              <React.Fragment key={index}>
                <div
                  className={"row-zone"}
                  style={{
                    height: `${rowZone.seats[0].height}px`,
                    top: `${rowZone.rowZone.coordinateY}px`,
                    left: `${rowZone.rowZone.coordinateX}px`,
                    lineHeight: `${rowZone.seats[0].height}px`,
                  }}
                >
                  {rowZone.rowZone.name}
                </div>
                {rowZone.seats.map((seat, index) => (
                  <div
                    key={index}
                    style={style(seat)}
                    className={isScreen(seat.name) ? "seat-screen" : `seat-zone ${seatStausClass(seat)}`}
                    onClick={() => handleSeat(seat, rowZone.rowZone)}
                  >
                    {seat.status === "U" ? `${seat.name}` : ""}
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
          <div className={"legend-panel"}>
            <div>
              <div className={"legend-free"}></div>
              <span>{t("wolne")}</span>
            </div>
            <div>
              <div className={"legend-busy"}></div>
              <span>{t("zajete")}</span>
            </div>
            <div>
              <div className={"legend-selected"}></div>
              <span>{t("wybrane")}</span>
            </div>
          </div>
        </React.Fragment>
      )}
    </LoadableComponent>
  );
};

export default CinemaHallDraw;
